import { DashHeaderProps } from "../../types/types";

const DashHeader: React.FC<DashHeaderProps> = ({ title, icon, onClick }) => {
  return (
    <>
      <div className="py-5 flex gap-4">
        <p className="font-semibold text-lg 2xl:text-2xl text-dark_dull">
          {title}
        </p>
        {icon && (
          <img
            src={icon}
            alt="plus"
            width={0}
            height={0}
            className="max-2xl:w-7 max-2xl:h-7 2xl:h-10 2xl:w-10 cursor-pointer"
            loading="lazy"
            onClick={onClick}
          />
        )}
      </div>
    </>
  );
};

export default DashHeader;
